import { CloudArrowUpIcon, CommandLineIcon } from '@heroicons/react/24/outline'
import { nodeHasChildren } from '@ui/lib/reactFlow/helpers'
import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { PanelEnum } from '@ui/interfaces'
import { useNodeAndEdgeStore } from '@ui/stores'

export function AddStepWizard() {
  const { setDisplayModal, edges, currentNodeId } = useNodeAndEdgeStore(
    useShallow((state) => ({
      setDisplayModal: state.setDisplayModal,
      edges: state.edges,
      currentNodeId: state.currentNodeId,
    }))
  )

  const hasChildNodes = useMemo(() => {
    if (!currentNodeId) return false
    return nodeHasChildren(edges, currentNodeId)
  }, [currentNodeId, edges])

  const steps = useMemo(() => {
    const steps = [
      {
        nodeType: PanelEnum.CODE,
        title: 'Transformation',
        description: 'Manipulate the stream of data',
        icon: CommandLineIcon,
      },
    ]
    // If current node has no children i.e end of the pipeline
    // Then it can possibily be a destination or export
    if (!hasChildNodes) {
      steps.push({
        nodeType: PanelEnum.DESTINATIONS,
        title: 'Send to',
        description: 'Batch and export the stream to a destination',
        icon: CloudArrowUpIcon,
      })
    }

    return steps
  }, [hasChildNodes])

  const onClick = (nodeType: PanelEnum) => {
    setDisplayModal(nodeType)
  }

  return (
    <div>
      <div className="mb-6 border-b border-gray-200 pb-5 pr-4 sm:pr-6">
        <div className="text-2xl font-medium leading-6 text-gray-900">Add step</div>
      </div>

      <div className="overflow-hidden">
        <div className="">
          {steps.map((step) => (
            <div data-testid={step.nodeType} key={step.nodeType} onClick={() => onClick(step.nodeType)}>
              <div className="group relative mb-2 flex cursor-pointer items-center gap-x-6 rounded-lg border border-slate-300 bg-white p-4 text-sm leading-6 duration-100 ease-in hover:border-primary-600 hover:bg-primary-100">
                <div className="flex size-11 flex-none items-center justify-center rounded-lg border border-slate-300 bg-gray-50 group-hover:border-primary-600">
                  <step.icon className="size-6 text-gray-600 group-hover:text-primary-600" aria-hidden="true" />
                </div>
                <div className="flex-auto">
                  <p className="block font-semibold">
                    {step.title}
                    <span className="absolute inset-0" />
                  </p>
                  <p className="mt-1 text-gray-600">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
